import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TokenService} from "../shared/service/token/token.service";
import { UtilService } from '../shared/service/util/util.service';

@Component({
  selector: 'app-ativacao-etoken-terceiros',
  templateUrl: './ativacao-etoken-terceiros.component.html',
  styleUrls: ['./ativacao-etoken-terceiros.component.css']
})
export class AtivacaoEtokenTerceirosComponent implements OnInit {
  public senhaTemporaria : string = "";
  public qrCodeValue : string = "";
  private codigoRequisicaoToken : string = "";
  public passo : string = "INICIO";
  private token : string = "";
  private userId : number = 0;
  private timerConclusaoInit: any;
  public tokenErrorMessage: string = "";

  constructor(
    private route: ActivatedRoute,
    private tokenService:TokenService,
    private utilService: UtilService) {

    this.route.params.subscribe(params => {
      this.token = params["token"];
      this.userId = Number(this.token.split(";")[0]);
    });
  }

  ngOnInit() {
  }

  iniciar(){
      const tokenB64 = btoa(this.token);
      this.tokenService.inicializacaoETokenTerceirosFase2(tokenB64).subscribe( (res) =>{
        this.senhaTemporaria =  res.senhaTemporaria;
        this.qrCodeValue =  JSON.stringify({eTokenSenha : res.senhaTemporaria});
        this.codigoRequisicaoToken = res.codigoRequisicao;
        this.passo="SHOW_QRCODE";
        this.registraTimerConclusao();
      }, (error) => {
        this.utilService.showError(error.message);
      });
  }

  registraTimerConclusao() {
    this.timerConclusaoInit = setInterval(() => {
      this.tokenService.inicializacaoConcluida(this.codigoRequisicaoToken, this.userId, true).subscribe(
        res => {
          if (res.concluida) {
            this.resetOtp();
            this.passo = 'MOSTRA_CONCLUIDO';
          }

          if (res.solicitacaoFalhou) {
            this.resetOtp();
            this.tokenErrorMessage = res.mensagemFalha;
          }
        },
        err => {
          this.tokenErrorMessage = err.message;
        }
      );
    }, 2000);
  }

  resetOtp() {
    this.senhaTemporaria = "";
    this.qrCodeValue = "";
    clearInterval(this.timerConclusaoInit);
  }
}